import { type ThunkAction } from "redux-thunk";
import {
  beginSearchAction,
  type HSAActions,
  loadInitialDataAction,
  searchFailAction,
  searchSuccessAction,
} from "./actions";
import { type RootState } from "../../redux/store";
import { fetchHousingSearchResults } from "../api/search/searchHousingAssistant";
import { getHousingClusterGroups } from "../api/getHousingClusterGroups";
import { getHousingSAFilterConfig } from "../api/getHousingSAFilterConfig";
import { type HousingSearchForm } from "../types/housingSAFormTypes";
import { NumberSystem } from "~/HousingSelectionAssistant/types/types";
import { selectFilterConfig } from "~/HousingSelectionAssistant/redux/selectors";
import { SearchReason } from "~/HousingSelectionAssistant/redux/types";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, HSAActions>;

export function initialiseHSAPage(query: HousingSearchForm): ThunkResult<void> {
  return async (dispatch, getState) => {
    const [searchResults, clusterGroupsData, metricTabularViewConfig, imperialTabularViewConfig] = await Promise.all([
      fetchHousingSearchResults(null, null),
      getHousingClusterGroups(),
      getHousingSAFilterConfig(NumberSystem.Metric),
      getHousingSAFilterConfig(NumberSystem.Imperial),
    ]);

    dispatch(
      loadInitialDataAction(
        metricTabularViewConfig.tabularViewColumnConfig,
        imperialTabularViewConfig.tabularViewColumnConfig,
        clusterGroupsData,
        searchResults
      )
    );
  };
}

export function runHSASearch(query: HousingSearchForm, searchReason: SearchReason): ThunkResult<void> {
  return async (dispatch, getState) => {
    dispatch(beginSearchAction(searchReason));

    try {
      const state = getState();
      const filterConfigMap = selectFilterConfig(state);
      let pageSize = state.housingSA.searchResults.pageSize!;
      if (searchReason === SearchReason.SORTING) {
        pageSize = pageSize * (query.page + 1);
        query = { ...query, page: 0 };
      }
      const results = await fetchHousingSearchResults(query, filterConfigMap, pageSize);
      dispatch(searchSuccessAction(results, searchReason));
    } catch (error) {
      console.error(error);
      dispatch(searchFailAction());
    }
  };
}
